import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Checkbox, FormControlLabel } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { DownloadMenuItem } from '../../common/DownloadMenuItem';
import { TableTooltipsChangedAction } from '../../common/datagrid';

type Props = {
    showTooltipsChangedAction: TableTooltipsChangedAction;
    tooltipsVisible: boolean;
    onDownloadClicked: () => void;
};

const PricesMenuButton = ({ tooltipsVisible, showTooltipsChangedAction, onDownloadClicked }: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const dispatch = useDispatch();
    const handleShowTooltips = (checked: boolean) => {
        dispatch(showTooltipsChangedAction({ showTooltips: checked }));
    };
    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <MoreVertIcon />
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button'
                }}
            >
                <MenuItem onClick={handleClose}>
                    <DownloadMenuItem onExportClicked={() => onDownloadClicked()} />
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={tooltipsVisible}
                                onChange={(_, checked) => handleShowTooltips(checked)}
                            />
                        }
                        label="Show tooltips"
                    />
                </MenuItem>
            </Menu>
        </div>
    );
};

export default PricesMenuButton;
